/*
 * Where: src/pages/NotFoundPage.js
 * What: Fallback page for unknown routes.
 * Why: Provide explicit recovery path when URL does not match.
 */
import React from 'react';
import { ROUTE_PATHS } from '../constants/routes';

function NotFoundPage({ onNavigate }) {
    return (
        <section className="hero-panel compact">
            <p className="hero-badge">ページ未検出</p>
            <h1>指定されたページは見つかりません。</h1>
            <p className="hero-description">
                トップページまたは使い方ページへ戻ってください。
            </p>
            <button
                className="solid-action"
                type="button"
                onClick={() => {
                    onNavigate(ROUTE_PATHS.top);
                }}
            >
                トップへ戻る
            </button>
        </section>
    );
}

export default NotFoundPage;
